import {
  getQuestionList,
  pathCreateQuestion,
  pathDeleteQuestion,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { questionActions } from "../reducers/question";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchQuestionList = (id_question = 0) => {
  return (dispatch) => {
    return apiService
      .get(getQuestionList(id_question))
      .then((response) => {
        id_question == 0
          ? dispatch(questionActions.fetchQuestionList(response.data))
          : dispatch(questionActions.fetchQuestionDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const clearQuestionDetail = () => {
  return (dispatch) => {
    dispatch(questionActions.fetchQuestionDetail([]));
  };
};

export const createNewQuestion = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.post(pathCreateQuestion(), data);
      navigate("/question-list");
      toast.success(t("questionsListActions.created"), {
        theme: "colored",
      });
    } catch (err) {
      handleError(err);
    }
  };
};

export const createNewQuestion1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateQuestion(), data)
      .then((response) => {
        // dispatch(questionActions.fetchQuestionList(response.data));
        toast.success(t("questionsListActions.created"), {
          theme: "colored",
        });
        navigate("/question-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditQuestion = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateQuestion(), data)
      .then((response) => {
        // dispatch(questionActions.fetchQuestionList(response.data));
        toast.success(t("questionsListActions.updated"), {
          theme: "colored",
        });
        navigate("/question-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteQuestion = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteQuestion(id))
      .then((response) => {
        toast.success(t("questionsListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchQuestionList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
